import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const Trucks_pending = () => {
  const [trucksPendingList, setTrucksPendingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  // ------------------------------
  // Alert Helper
  // ------------------------------
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    try {
      const response = await post("/operations/trucks_pending/list");
      if (response.status === 200) {
        setTrucksPendingList(response.data);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    }
  }, [showAlert]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "Job Ref", accessorKey: "job_no" },
      { header: "BL No.", accessorKey: "bl_no" },
      { header: "Description", accessorKey: "description" },
      { header: "Wt (MT)", accessorKey: "weight" },
      { header: "BE No.", accessorKey: "be_no"},
      { header: "Lorry No.", accessorKey: "lorry_no" },
      { header: "Driver Phone", accessorKey: "driver_phone" },
      { header: "Despatch Date", accessorKey: "despatch_date" },
      { header: "Days Pending", accessorKey: "days_pending" },
      { header: "Action", accessorKey: "action" }
      
    ],
    []
  );
  // ------------------------------
  // Render
  // ------------------------------
  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">Trucks Not Reached</div>
          <div className="page-header-sub">{trucksPendingList.length} pending trucks</div>
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">Trucks Not Reached</h5>
        </div>
        <div className="card-body">
          <Customtable
            table_title="Trucks Not Reached"
            columns={columns}
            data={trucksPendingList}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isExportButton={true}
          />
        </div>
      </div>
    </>
  );
};

export default Trucks_pending;